import * as React from "react";
import { useContext } from "react";
import FieldType from "views/logic/fieldtypes/FieldType";
import Action from "views/components/actions/Action";
import { ActionContext } from "views/logic/ActionContext";
import useFieldActions from "views/components/actions/useFieldActions";
const ValueActions = ({
  children,
  element,
  field,
  menuContainer = document.body,
  type = FieldType.Unknown,
  value
}) => {
  const actionContext = useContext(ActionContext);
  const { additionalHandlerArgs } = useFieldActions();
  const handlerArgs = {
    field,
    type,
    value,
    contexts: actionContext,
    ...additionalHandlerArgs
  };
  const elementWithStatus = () => element;
  return /* @__PURE__ */ React.createElement(Action, { element: elementWithStatus, handlerArgs, menuContainer, type: "value" }, children);
};
export default ValueActions;
